import React from "react";
import { MainLayout } from "layouts";
import { navigate } from "shared/utils";
import { TaskDetail } from "./components/TaskDetail";
import { TaskEmptyState } from "./components/TaskEmptyState";
import { TaskList } from "./components/TaskList";
import { useTaskBoardStore } from "./hooks/useTaskBoardStore";
import { useTaskBoardView } from "./hooks/useTaskBoardView";

export const ActivityLogPage: React.FC = () => {
	const { state, teams, workspace, isLoading, refresh, setSelectedTaskId } = useTaskBoardStore();
	const workspaceId = workspace ? String(workspace.id) : null;

	const {
		sidebarGroups,
		sidebarSearch,
		setSidebarSearch,
		statusFilter,
		setStatusFilter,
		selectedTask,
		filteredTaskItems,
		statusCounts,
		headerStats,
	} = useTaskBoardView({ state, teams });

	const hasTasks = state.taskIds.length > 0;
	const shouldRenderEmptyState = !hasTasks || !selectedTask;

	const handleSelectFirstTask = React.useCallback(() => {
		const firstTaskId = state.taskIds[0];
		if (!firstTaskId) return;
		setSelectedTaskId(firstTaskId);
	}, [state.taskIds, setSelectedTaskId]);

	return (
		<MainLayout
			sidebar={
				<TaskList
					groups={sidebarGroups}
					selectedTaskId={state.selectedTaskId}
					sidebarSearch={sidebarSearch}
					onSidebarSearch={setSidebarSearch}
					onSelectTask={setSelectedTaskId}
					onRefresh={refresh}
					isLoading={isLoading}
				/>
			}
		>
			{shouldRenderEmptyState ? (
				<TaskEmptyState
					hasTasks={hasTasks}
					isLoading={isLoading}
					onSelectFirstTask={handleSelectFirstTask}
				/>
			) : (
				<TaskDetail
					selectedTaskObjective={selectedTask.objective}
					selectedTaskStatus={selectedTask.status}
					selectedTaskCancellation={
						selectedTask.cancelledAt
							? {
									cancelledAt: selectedTask.cancelledAt,
									reason: selectedTask.cancellationReason,
								}
							: null
					}
					headerStats={headerStats}
					statusCounts={statusCounts}
					statusFilter={statusFilter}
					onStatusFilterChange={setStatusFilter}
					items={filteredTaskItems}
					isLoading={isLoading}
					workspaceId={workspaceId}
					selectedTaskId={selectedTask.id}
					state={state}
					onCancelled={refresh}
				/>
			)}
		</MainLayout>
	);
};
